/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/common/js/modules/megamenu.ts":
/*!*******************************************!*\
  !*** ./src/common/js/modules/megamenu.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* provided dependency */ var util = __webpack_require__(/*! ./src/common/js/modules/utility */ "./src/common/js/modules/utility.ts")["default"];
/*!
 *
 *  megamenu.js
 *
 */
var Megamenu = /** @class */ (function () {
    function Megamenu(elem) {
        var _this = this;
        this.speed = 500;
        this.easing = 'cubic-bezier(0.25, 1, 0.5, 1)';
        this.openEvent = new Event('open');
        this.closeEvent = new Event('close');
        this.handleMenuTransitionEnd = function (e) {
            if (e.propertyName === 'height') {
                _this.menu.style.transition = '';
                if (_this.btn.getAttribute('aria-expanded') === 'true') {
                    _this.menu.style.height = '';
                }
                ;
            }
        };
        this.elem = elem;
        this.btn = this.elem.querySelector('.site-global__link');
        this.menu = this.elem.querySelector('.site-megamenu');
        this.menuInner = this.menu.children[0];
        this.init();
    }
    Megamenu.prototype.init = function () {
        // this.elem.addEventListener('mouseenter', () => {
        // 	if (util.viewport !== 'phone' && util.viewport !== 'tablet' && !util.isTouchDevice) {
        // 		this.open();
        // 	};
        // })
        // this.elem.addEventListener('mouseleave', () => {
        // 	if (util.viewport !== 'phone' && util.viewport !== 'tablet' && !util.isTouchDevice) {
        // 		this.close();
        // 	};
        // });
        var _this = this;
        this.btn.addEventListener('click', function (e) {
            e.preventDefault();
            if (_this.btn.getAttribute('aria-expanded') === 'true') {
                _this.close();
            }
            else {
                _this.open();
            }
            ;
        });
        document.addEventListener('click', function (e) {
            if (_this.btn.getAttribute('aria-expanded') === 'true'
                && !e.target.closest(".".concat(_this.menu.className))
                && !e.target.closest(".".concat(_this.btn.className))) {
                _this.close();
            }
        });
        this.menu.addEventListener('transitionend', this.handleMenuTransitionEnd);
    };
    Megamenu.prototype.open = function () {
        var _this = this;
        var h = this.menuInner.offsetHeight;
        this.menu.style.height = "0";
        setTimeout(function () {
            _this.btn.setAttribute('aria-expanded', 'true');
            _this.menu.setAttribute('aria-hidden', 'false');
            _this.menu.style.transition = "height ".concat(_this.speed, "ms ").concat(_this.easing, ", visibility ").concat(_this.speed, "ms");
            _this.menu.style.height = "".concat(h, "px");
        }, 10);
        this.elem.dispatchEvent(this.openEvent);
    };
    Megamenu.prototype.close = function () {
        var _this = this;
        var h = this.menuInner.offsetHeight;
        this.menu.style.height = "".concat(h, "px");
        setTimeout(function () {
            _this.btn.setAttribute('aria-expanded', 'false');
            _this.menu.setAttribute('aria-hidden', 'true');
            _this.menu.style.transition = "height ".concat(_this.speed, "ms ").concat(_this.easing, ", visibility ").concat(_this.speed, "ms");
            _this.menu.style.height = '0px';
        }, 10);
        this.elem.dispatchEvent(this.closeEvent);
    };
    return Megamenu;
}());
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
    var elems = document.querySelectorAll('.site-global__item.-megamenu');
    var megamenu = Array.from(elems).map(function (elem) {
        return new Megamenu(elem);
    });
    megamenu.forEach(function (menu) {
        menu.elem.addEventListener('open', function () {
            if (util.viewport !== 'phone' && util.viewport !== 'tablet') {
                megamenu.forEach(function (m) {
                    if (m !== menu) {
                        m.close();
                    }
                    ;
                });
                util.overlay.setAttribute('aria-hidden', 'false');
            }
            ;
        });
        menu.elem.addEventListener('close', function () {
            if (util.viewport !== 'phone' && util.viewport !== 'tablet') {
                var hasOpenMenu_1 = false;
                megamenu.forEach(function (m) {
                    if (m.elem.getAttribute('aria-hidden') === 'false') {
                        hasOpenMenu_1 = true;
                    }
                    ;
                });
                if (!hasOpenMenu_1) {
                    util.overlay.setAttribute('aria-hidden', 'true');
                }
                ;
            }
            ;
        });
        var links = menu.menu.querySelectorAll('a');
        Array.from(links).forEach(function (link) {
            link.addEventListener('click', function () {
                menu.close();
            });
        });
    });
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.site-global__item.-megamenu')
            && util.viewport !== 'phone'
            && util.viewport !== 'tablet') {
            megamenu.forEach(function (m) {
                m.close();
            });
        }
    });
}


/***/ }),

/***/ "./src/common/js/modules/menu.ts":
/*!***************************************!*\
  !*** ./src/common/js/modules/menu.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* provided dependency */ var util = __webpack_require__(/*! ./src/common/js/modules/utility */ "./src/common/js/modules/utility.ts")["default"];
/*!
 *
 *  menu.ts
 *
 */
var SiteMenu = /** @class */ (function () {
    function SiteMenu(options) {
        var _this = this;
        this.toggleMenu = function () {
            var isMenuOpen = _this.container.getAttribute('aria-hidden') === 'false';
            var html = document.querySelector('html');
            var scrollControll = _this.scrollControll.bind(_this);
            var eventType = isMenuOpen ? 'removeEventListener' : 'addEventListener';
            var passive = { passive: false };
            var classType = isMenuOpen ? 'remove' : 'add';
            _this.btn.setAttribute('aria-pressed', "".concat(!isMenuOpen));
            _this.container.setAttribute('aria-hidden', "".concat(isMenuOpen));
            html.style.overflow = isMenuOpen ? 'auto' : 'hidden';
            document[eventType]('touchmove', scrollControll, passive);
            _this.header.classList[classType]('-open-menu');
            if (util.overlay) {
                util.overlay.setAttribute('aria-hidden', "".concat(isMenuOpen));
            }
        };
        this.closeMenu = function () {
            _this.btn.setAttribute('aria-pressed', 'false');
            _this.container.setAttribute('aria-hidden', 'true');
            document.querySelector('html').style.overflow = 'auto';
            document.removeEventListener('touchmove', _this.scrollControll);
            _this.header.classList.remove('-open-menu');
            if (util.overlay) {
                util.overlay.setAttribute('aria-hidden', 'true');
            }
        };
        this.scrollControll = function (e) {
            var isMenuOpen = _this.container.getAttribute('aria-hidden') === 'false';
            var inner = e.target.closest('.site-menu__body__inner');
            if (isMenuOpen) {
                if (inner) {
                    if (inner.scrollHeight > inner.clientHeight) {
                        e.stopPropagation();
                    }
                    else {
                        e.preventDefault();
                    }
                }
                else {
                    e.preventDefault();
                }
                ;
            }
            ;
        };
        if (!document.querySelector(options.btn))
            return;
        this.btn = document.querySelector(options.btn);
        this.container = document.querySelector(options.container);
        this.containerName = options.container;
        this.header = document.getElementById('header');
        this.btn.addEventListener('click', this.toggleMenu);
        document.addEventListener('click', function (e) {
            if ((_this.container.getAttribute('aria-hidden') === 'false'
                && !e.target.closest('#site-contact')
                && !e.target.closest(_this.containerName)
                && !e.target.closest(options.btn))
                || e.target.classList.contains('site-menu__body')) {
                _this.closeMenu();
            }
        });
        window.addEventListener('viewportChanged', this.viewportCheck.bind(this));
        var links = document.querySelectorAll('.site-menu__main a:not(.site-global__link)');
        links.forEach(function (link) {
            link.addEventListener('click', function (e) {
                _this.closeMenu();
            });
        });
        var access = document.querySelector('.site-global__link[href="#access"]');
        if (access) {
            access.addEventListener('click', function (e) {
                _this.closeMenu();
            });
        }
        ;
        this.viewportCheck();
    }
    SiteMenu.prototype.viewportCheck = function () {
        var shouldHide = ['phone', 'tablet'].includes(util.viewport);
        this.container.setAttribute('aria-hidden', "".concat(shouldHide));
    };
    return SiteMenu;
}());
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SiteMenu);


/***/ }),

/***/ "./src/common/js/modules/scroll2hash.ts":
/*!**********************************************!*\
  !*** ./src/common/js/modules/scroll2hash.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* provided dependency */ var util = __webpack_require__(/*! ./src/common/js/modules/utility */ "./src/common/js/modules/utility.ts")["default"];
/*!
 *
 *  scroll2hash.js
 *
 */
var scroll2hash = function () {
    var hash = util.hash;
    if (hash.length > 0 && !hash.includes('/')) {
        location.hash = "".concat(hash, "_");
        window.addEventListener('load', function () {
            var target = document.querySelector(hash);
            if (target) {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                var top_1 = target.getBoundingClientRect().top + scrollTop - util.scrollGap;
                setTimeout(function () {
                    window.scrollTo({ top: top_1, behavior: 'auto' });
                }, 10);
                history.replaceState(null, '', util.hash);
            }
            else {
                history.replaceState(null, '', util.hash);
            }
        });
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (scroll2hash);


/***/ }),

/***/ "./src/common/js/modules/sitemap.ts":
/*!******************************************!*\
  !*** ./src/common/js/modules/sitemap.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* provided dependency */ var util = __webpack_require__(/*! ./src/common/js/modules/utility */ "./src/common/js/modules/utility.ts")["default"];
/*!
 *
 *  sitemap.js
 *
 */
var Sitemap = /** @class */ (function () {
    function Sitemap(elem) {
        var _this = this;
        this.speed = 500;
        this.easing = 'cubic-bezier(0.25, 1, 0.5, 1)';
        this.handleMenuTransitionEnd = function (e) {
            if (e.propertyName === 'height') {
                _this.menu.style.transition = '';
                if (_this.btn.getAttribute('aria-expanded') === 'true') {
                    _this.menu.style.height = '';
                }
                ;
            }
        };
        this.btn = elem;
        this.menu = document.querySelector("#".concat(this.btn.getAttribute('aria-controls')));
        this.init();
    }
    Sitemap.prototype.init = function () {
        var _this = this;
        this.btn.addEventListener('click', function (e) {
            if (util.viewport === 'phone') {
                e.preventDefault();
                if (_this.btn.getAttribute('aria-expanded') === 'true') {
                    _this.close();
                }
                else {
                    _this.open();
                }
                ;
            }
            else {
                if (e.currentTarget.classList.contains('-disabled')) {
                    e.preventDefault();
                }
                ;
            }
            ;
        });
        this.menu.addEventListener('transitionend', this.handleMenuTransitionEnd);
        window.addEventListener('viewportChanged', this.viewportCheck.bind(this));
        this.viewportCheck();
    };
    Sitemap.prototype.open = function () {
        var _this = this;
        var h = this.menu.scrollHeight;
        this.menu.style.height = "0";
        setTimeout(function () {
            _this.btn.setAttribute('aria-expanded', 'true');
            _this.menu.setAttribute('aria-hidden', 'false');
            _this.menu.style.transition = "height ".concat(_this.speed, "ms ").concat(_this.easing, ", visibility ").concat(_this.speed, "ms");
            _this.menu.style.height = "".concat(h, "px");
        }, 10);
        if (util.viewport !== 'phone') {
            util.overlay.setAttribute('aria-hidden', 'false');
        }
    };
    Sitemap.prototype.close = function () {
        var _this = this;
        var h = this.menu.scrollHeight;
        this.menu.style.height = "".concat(h, "px");
        setTimeout(function () {
            _this.btn.setAttribute('aria-expanded', 'false');
            _this.menu.setAttribute('aria-hidden', 'true');
            _this.menu.style.transition = "height ".concat(_this.speed, "ms ").concat(_this.easing, ", visibility ").concat(_this.speed, "ms");
            _this.menu.style.height = '0px';
        }, 10);
        if (util.viewport !== 'phone') {
            util.overlay.setAttribute('aria-hidden', 'true');
        }
    };
    Sitemap.prototype.viewportCheck = function () {
        var shouldHide = ['phone'].includes(util.viewport);
        if (shouldHide) {
            this.btn.setAttribute('aria-expanded', 'false');
            this.menu.setAttribute('aria-hidden', 'true');
        }
        else {
            this.btn.setAttribute('aria-expanded', 'true');
            this.menu.setAttribute('aria-hidden', 'false');
        }
        ;
    };
    return Sitemap;
}());
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
    var sitemaplink = document.querySelectorAll('.site-sitemap__link[aria-expanded]');
    sitemaplink.forEach(function (elem) {
        new Sitemap(elem);
    });
}


/***/ }),

/***/ "./src/common/js/modules/smooth-scroll.ts":
/*!************************************************!*\
  !*** ./src/common/js/modules/smooth-scroll.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   smoothScrollCore: () => (/* binding */ smoothScrollCore)
/* harmony export */ });
/* provided dependency */ var util = __webpack_require__(/*! ./src/common/js/modules/utility */ "./src/common/js/modules/utility.ts")["default"];
/*!
 *
 *  smooth-scroll.ts
 *
 */
var smoothScrollCore = function (target, duration) {
    var html = document.getElementsByTagName('html')[0];
    var body = document.getElementsByTagName('body')[0];
    var targetPosition = target.getBoundingClientRect().top + (window.pageYOffset || html.scrollTop || body.scrollTop) - util.scrollGap;
    var startPosition = window.pageYOffset || html.scrollTop || body.scrollTop;
    var distance = targetPosition - startPosition;
    if (duration <= 0) {
        window.scrollTo(0, targetPosition);
        return;
    }
    ;
    var startTime = null;
    var animation = function (currentTime) {
        if (startTime === null) {
            startTime = currentTime;
        }
        var timeElapsed = currentTime - startTime;
        var run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        }
    };
    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1)
            return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }
    ;
    requestAnimationFrame(animation);
};
var smoothScroll = function (options) {
    if (options === void 0) { options = {}; }
    var ignore = options.ignore || '[data-scroll-ignore]';
    var duration = options.duration || 700;
    var links = document.querySelectorAll("a[href^=\"#\"]:not(".concat(ignore, ", [data-open-contact] > a), a[href^=\"").concat(location.pathname, "#\"]:not(").concat(ignore, "), a[href^=\"").concat(location.origin).concat(location.pathname, "#\"]:not(").concat(ignore, ")"));
    links.forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var href = link.getAttribute('href').replace(location.origin, '').replace(location.pathname, '');
            var target = document.querySelector(href);
            if (target) {
                setTimeout(function () {
                    smoothScrollCore(target, duration);
                }, 1);
            }
        });
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (smoothScroll);


/***/ }),

/***/ "./src/common/js/modules/utility.ts":
/*!******************************************!*\
  !*** ./src/common/js/modules/utility.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*!
 *
 * utility.ts
 *
 */
var BREAKPOINTS = {
    phone: 768,
    tablet: 993,
    desktop: 1220,
    largeDesktop: Infinity,
};
var gap = {
    selector: 'header',
    spselector: 'header',
    viewport: {
        phone: true,
        tablet: true,
        desktop: true,
        largeDesktop: true,
    },
};
var getViewport = function (ww) {
    if (ww < BREAKPOINTS.phone) {
        return 'phone';
    }
    else if (ww < BREAKPOINTS.tablet) {
        return 'tablet';
    }
    else if (ww < BREAKPOINTS.desktop) {
        return 'desktop';
    }
    else {
        return 'largeDesktop';
    }
};
var setScrollGap = function (viewport) {
    var gapSelector = viewport === 'phone' ? gap.spselector : gap.selector;
    var gapElement = document.getElementById(gapSelector);
    var hasGapElement = gapElement !== null;
    var gapHeight = hasGapElement ? gapElement.offsetHeight : 112;
    var gapMargin = viewport !== 'phone' ? 16 : 16;
    var addNav = document.querySelector('[data-add-header]') !== null ? document.querySelector('[data-add-header]').offsetHeight : 0;
    return gapHeight + gapMargin + addNav;
};
var getScrollbarWidth = function () {
    var element = document.createElement('div');
    element.style.visibility = 'hidden';
    element.style.overflow = 'scroll';
    document.body.appendChild(element);
    var scrollbarWidth = element.offsetWidth - element.clientWidth;
    document.body.removeChild(element);
    return scrollbarWidth;
};
var html = document.documentElement;
var setSize = function () {
    var vh = window.innerHeight * 0.01;
    html.style.setProperty('--vh', "".concat(vh, "px"));
    var scrollbarWidth = getScrollbarWidth();
    if (scrollbarWidth > 0) {
        html.style.setProperty('--scroll-bar', "".concat(scrollbarWidth, "px"));
    }
};
var telLinkManager = function () {
    var telLinks = document.querySelectorAll("a[href^=\"tel:\"]");
    var isPhone = /iPhone|Android/.test(navigator.userAgent);
    if (isPhone) {
        telLinks.forEach(function (link) {
            link.classList.add('u-tel', '-enabled');
        });
    }
    else {
        telLinks.forEach(function (link) {
            link.classList.add('u-tel', '-disabled');
            // link.addEventListener('click', (e) => {
            // 	e.preventDefault();
            // });
        });
    }
    ;
};
var handleResize = function () {
    var newViewport = getViewport(window.innerWidth);
    if (util.viewport !== newViewport) {
        util.viewport = newViewport;
        window.dispatchEvent(viewportChanged);
    }
    util.scrollGap = setScrollGap(newViewport);
    setSize();
};
var handleLoad = function () {
    util.scrollGap = setScrollGap(util.viewport);
    util.overlay = document.getElementById('overlay');
    telLinkManager();
    setSize();
};
var initUtil = function () {
    var initialViewport = getViewport(window.innerWidth);
    var util = {
        ww: window.innerWidth,
        wh: window.innerHeight,
        hash: location.hash,
        viewport: initialViewport,
        scroller: 'html,body',
        scrollGap: setScrollGap(initialViewport),
        isTouchDevice: 'ontouchstart' in window,
        overlay: null,
    };
    if (util.isTouchDevice) {
        var body = document.body;
        body.setAttribute('ontouchstart', '');
    }
    return util;
};
var util = initUtil();
var viewportChanged = new CustomEvent('viewportChanged');
window.addEventListener('resize', handleResize, { passive: true });
document.readyState !== "loading" ? handleLoad() : document.addEventListener("DOMContentLoaded", handleLoad);
window.addEventListener('load', handleLoad, { passive: true });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (util);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + chunkId + ".js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "shinkokai:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		var scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		var document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript)
/******/ 				scriptUrl = document.currentScript.src;
/******/ 			if (!scriptUrl) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) {
/******/ 					var i = scripts.length - 1;
/******/ 					while (i > -1 && (!scriptUrl || !/^http(s?):/.test(scriptUrl))) scriptUrl = scripts[i--].src;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"bundle": 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshinkokai"] = self["webpackChunkshinkokai"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!*************************************************!*\
  !*** ./src/tachikawakitaguchi-ladies/js/app.ts ***!
  \*************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var scroll2hash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! scroll2hash */ "./src/common/js/modules/scroll2hash.ts");
/* harmony import */ var smooth_scroll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! smooth-scroll */ "./src/common/js/modules/smooth-scroll.ts");
/* harmony import */ var menu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! menu */ "./src/common/js/modules/menu.ts");
/* harmony import */ var megamenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! megamenu */ "./src/common/js/modules/megamenu.ts");
/* harmony import */ var sitemap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! sitemap */ "./src/common/js/modules/sitemap.ts");
/*!
 *
 * app.js
 *
 */
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*** ./modules **/





(0,scroll2hash__WEBPACK_IMPORTED_MODULE_0__["default"])();
function init() {
    (0,smooth_scroll__WEBPACK_IMPORTED_MODULE_1__["default"])({
        ignore: '[data-ignore-smoothscroll], .site-global__item.-megamenu .site-global__link, .site-sitemap__link',
    });
    new menu__WEBPACK_IMPORTED_MODULE_2__["default"]({
        btn: '#menuBtn',
        container: '#menuContainer',
    });
    (0,megamenu__WEBPACK_IMPORTED_MODULE_3__["default"])();
    (0,sitemap__WEBPACK_IMPORTED_MODULE_4__["default"])();
    initScrollable();
    initTab();
    initFaq();
    initAccordion();
    initTopSlider();
    // initTopImportantSlider();
    initCourseSlider();
    initLoopGallery();
    initGallery();
    initRankingSlider();
    initForm();
    initPickupSlider();
}
;
function initTopSlider() {
    return __awaiter(this, void 0, void 0, function () {
        var elem, topSlider;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elem = document.querySelector('#topSlider');
                    if (!elem) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(/*! import() | top-slider */[__webpack_require__.e("vendors-node_modules_swiper_swiper_css-node_modules_swiper_swiper_mjs"), __webpack_require__.e("vendors-node_modules_swiper_modules_index_mjs"), __webpack_require__.e("top-slider")]).then(__webpack_require__.bind(__webpack_require__, /*! top-slider */ "./src/common/js/modules/top-slider.ts"))];
                case 1:
                    topSlider = (_a.sent()).default;
                    topSlider(elem);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initTopImportantSlider() {
    return __awaiter(this, void 0, void 0, function () {
        var elem, topImportantSlider;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elem = document.querySelector('#topImportantSlider');
                    if (!elem) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(/*! import() | top-important-slider */[__webpack_require__.e("vendors-node_modules_swiper_swiper_css-node_modules_swiper_swiper_mjs"), __webpack_require__.e("top-important-slider")]).then(__webpack_require__.bind(__webpack_require__, /*! top-important-slider */ "./src/common/js/modules/top-important-slider.ts"))];
                case 1:
                    topImportantSlider = (_a.sent()).default;
                    topImportantSlider(elem);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initCourseSlider() {
    return __awaiter(this, void 0, void 0, function () {
        var elem, topCourseSlider;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elem = document.querySelector('#topCourseSlider');
                    if (!elem) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(/*! import() | top-course-slider */[__webpack_require__.e("vendors-node_modules_swiper_swiper_css-node_modules_swiper_swiper_mjs"), __webpack_require__.e("vendors-node_modules_swiper_modules_index_mjs"), __webpack_require__.e("top-course-slider")]).then(__webpack_require__.bind(__webpack_require__, /*! top-course-slider */ "./src/common/js/modules/top-course-slider.ts"))];
                case 1:
                    topCourseSlider = (_a.sent()).default;
                    topCourseSlider(elem);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initLoopGallery() {
    return __awaiter(this, void 0, void 0, function () {
        var elems, loogGallery;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elems = document.querySelectorAll('.c-loop-gallery');
                    if (!(elems.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e(/*! import() | loop-gallery */ "loop-gallery").then(__webpack_require__.bind(__webpack_require__, /*! loop-gallery */ "./src/common/js/modules/loop-gallery.ts"))];
                case 1:
                    loogGallery = (_a.sent()).default;
                    loogGallery(elems);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initScrollable() {
    return __awaiter(this, void 0, void 0, function () {
        var elems, scrollable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elems = document.querySelectorAll('.u-scrollable');
                    if (!(elems.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e(/*! import() | scrollable */ "scrollable").then(__webpack_require__.bind(__webpack_require__, /*! scrollable */ "./src/common/js/modules/scrollable.ts"))];
                case 1:
                    scrollable = (_a.sent()).default;
                    scrollable('.u-scrollable');
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initFaq() {
    return __awaiter(this, void 0, void 0, function () {
        var elems, Accordion;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elems = document.querySelectorAll('.c-faq');
                    if (!(elems.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e(/*! import() | accordion */ "accordion").then(__webpack_require__.bind(__webpack_require__, /*! accordion */ "./src/common/js/modules/accordion.ts"))];
                case 1:
                    Accordion = (_a.sent()).default;
                    Accordion('.c-faq', {
                        containerSelector: '.c-faq__item',
                        headSelector: '.c-faq__head',
                        bodySelector: '.c-faq__body',
                    });
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initAccordion() {
    return __awaiter(this, void 0, void 0, function () {
        var elems, Accordion;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elems = document.querySelectorAll('.c-accordion');
                    if (!(elems.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e(/*! import() | accordion */ "accordion").then(__webpack_require__.bind(__webpack_require__, /*! accordion */ "./src/common/js/modules/accordion.ts"))];
                case 1:
                    Accordion = (_a.sent()).default;
                    Accordion('.c-accordion', {
                        containerSelector: '.c-accordion__item',
                        headSelector: '.c-accordion__head',
                        bodySelector: '.c-accordion__body',
                    });
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initTab() {
    return __awaiter(this, void 0, void 0, function () {
        var elems, Tab;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elems = document.querySelectorAll('.c-tab');
                    if (!(elems.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e(/*! import() | tab */ "tab").then(__webpack_require__.bind(__webpack_require__, /*! tab */ "./src/common/js/modules/tab.ts"))];
                case 1:
                    Tab = (_a.sent()).default;
                    Tab('.c-tab');
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initForm() {
    return __awaiter(this, void 0, void 0, function () {
        var elem, Form;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elem = document.querySelector('#form');
                    if (!elem) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(/*! import() | form */[__webpack_require__.e("vendors-node_modules_axios_index_js-node_modules_vuepic_vue-datepicker_dist_main_css-node_mod-8f1edc"), __webpack_require__.e("form")]).then(__webpack_require__.bind(__webpack_require__, /*! form */ "./src/common/js/modules/form.ts"))];
                case 1:
                    Form = (_a.sent()).default;
                    Form();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initGallery() {
    return __awaiter(this, void 0, void 0, function () {
        var elems, Gallery;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elems = document.querySelectorAll('.c-gallery');
                    if (!(elems.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(/*! import() | gallery */[__webpack_require__.e("vendors-node_modules_swiper_swiper_css-node_modules_swiper_swiper_mjs"), __webpack_require__.e("vendors-node_modules_swiper_modules_index_mjs"), __webpack_require__.e("gallery")]).then(__webpack_require__.bind(__webpack_require__, /*! gallery */ "./src/common/js/modules/gallery.ts"))];
                case 1:
                    Gallery = (_a.sent()).default;
                    Gallery(elems);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initRankingSlider() {
    return __awaiter(this, void 0, void 0, function () {
        var elems, RankingSlider;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elems = document.querySelectorAll('.opt-ranking');
                    if (!(elems.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(/*! import() | ranking-slider */[__webpack_require__.e("vendors-node_modules_swiper_swiper_css-node_modules_swiper_swiper_mjs"), __webpack_require__.e("vendors-node_modules_swiper_modules_index_mjs"), __webpack_require__.e("ranking-slider")]).then(__webpack_require__.bind(__webpack_require__, /*! ranking-slider */ "./src/common/js/modules/ranking-slider.ts"))];
                case 1:
                    RankingSlider = (_a.sent()).default;
                    RankingSlider(elems);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function initPickupSlider() {
    return __awaiter(this, void 0, void 0, function () {
        var elem, PickupSlider;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    elem = document.querySelector('.top-pickup-slider');
                    if (!elem) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(/*! import() | top-pickup-slider */[__webpack_require__.e("vendors-node_modules_swiper_swiper_css-node_modules_swiper_swiper_mjs"), __webpack_require__.e("vendors-node_modules_swiper_modules_index_mjs"), __webpack_require__.e("top-pickup-slider")]).then(__webpack_require__.bind(__webpack_require__, /*! top-pickup-slider */ "./src/common/js/modules/top-pickup-slider.ts"))];
                case 1:
                    PickupSlider = (_a.sent()).default;
                    PickupSlider(elem);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
document.readyState !== "loading" ? init() : document.addEventListener("DOMContentLoaded", init);

})();

/******/ })()
;